module.exports = global["$"] = require("-!/var/www/ridewithgps.com/releases/20261103180724/node_modules/expose-loader/index.js?jQuery!./jquery-2.2.3.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./public/javascripts/jquery-2.2.3.js-exposed
// module id = 31
// module chunks = 0